import { Button } from "ui/button/button";
import { type ButtonProps } from "ui/button/button.types";
import { mergeSx } from "ui/merge-sx";
import { TEXT_BUTTON_SX } from "ui/text-button/text-button.styles";

/** `variant` is the component itself; `disableElevation` has no elevation to remove on a text button. */
export type TextButtonProps = Omit<ButtonProps, "variant" | "disableElevation">;

/**
 * Figma `Button`, `variant=text`: a bare label with optional icons, for popover triggers and a modal's
 * back action. `ui/button`'s own `variant="text"` keeps its padded box and hover tint.
 */
export const TextButton = ({ sx, ...props }: TextButtonProps) => (
  <Button {...props} variant="text" sx={mergeSx(TEXT_BUTTON_SX, sx)} />
);
